import { imagePath } from "../../../../utils/imagePath"

const VrTechnologyData =  {
    slug: 'concepts/vr',
    sectionTitle: 'VR Technology',
    blocks: [
      {
        type: 'text',
        content: [
          'Virtual Reality (VR) creates fully immersive digital environments that place users inside a completely virtual world. Unlike traditional screens, VR surrounds users with a 360° experience, allowing them to look around, move, and interact as if they are physically present in the digital space.',
          'Using VR headsets and controllers, users are transported into simulated environments designed for learning, exploration, training, and storytelling.',
        ],
      },
      {
        type: 'image',
        src: imagePath?.VRTecnology,
        alt: 'Dashboard',
      },
    ],
    subSections: [
      {
        title: '2.1  How VR Works',
        blocks: [
          {
            type: 'text',
            content: [
              'VR uses specialized hardware and software to simulate reality:',
            ],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              '**Headsets** display stereoscopic 3D visuals for depth and immersion',
              '**Motion tracking** follows head and hand movements in real time',
              '**Controllers or hand tracking** enable interaction with virtual objects',
              '**Spatial audio** enhances realism by matching sound to movement',
            ],
          },
          {
            type: 'text',
            content: [
              'As users move their head or hands, the virtual world responds instantly—creating a strong sense of presence.',
            ],
          },
        ],
      },
      {
        title: '2.2 What Makes VR Immersive',
        blocks: [
          {
            type: 'text',
            content: ['VR replaces the real world with a digital one by:'],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Blocking out physical surroundings',
              'Providing a wide field of view',
              'Responding naturally to movement',
              'Allowing direct interaction with virtual elements',
            ],
          },
          {
            type: 'text',
            content: [
              'This makes VR experiences feel realistic, engaging, and deeply immersive.',
            ],
          },
        ],
      },
      {
        title: '2.3 What You Can Create with VR',
        blocks: [
          {
            type: 'text',
            content: 'VR enables powerful experiences such as:',
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              '**Training simulations** for safety, operations, and skills development',
              '**Virtual walkthroughs** of environments or designs',
              'Immersive learning experiences',
              'Product and environment visualizations',
              'Interactive storytelling and simulations',
            ],
          },
          {
            type: 'text',
            content:
              'VR experiences are ideal when full focus and immersion are required.',
          },
        ],
      },
    ],
}
  export default VrTechnologyData